// extracted by css-extract-rspack-plugin
export default {"button":"_45b2f2b"};